"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("../index.scss");
var Shapes = _interopRequireWildcard(require("../shapes"));
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Offers = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Offers, _React$Component);
  var _super = _createSuper(Offers);
  function Offers() {
    var _this;
    (0, _classCallCheck2.default)(this, Offers);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedRadio: null
    });
    return _this;
  }
  (0, _createClass2.default)(Offers, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var checkBoxDiv = 'checkBox-offer-div-';
      return this.props.offers && this.props.offers.length ? /*#__PURE__*/_react.default.createElement("div", null, this.props.offers.map(function (offer, idx) {
        return _this2.props.inValidInput ? /*#__PURE__*/_react.default.createElement("div", {
          className: "card-offer"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "adx-inputclass"
        }, /*#__PURE__*/_react.default.createElement("input", {
          type: "radio",
          name: "offer",
          className: "card-offer-checkbox",
          disabled: true
        })), /*#__PURE__*/_react.default.createElement("label", {
          className: "adx-card-offer-value--disbaled"
        }, /*#__PURE__*/_react.default.createElement("strong", null, "Min ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
          value: Math.ceil(offer.minimumAmount),
          displayType: 'text',
          thousandSeparator: true,
          prefix: '$',
          suffix: ' '
        })), /*#__PURE__*/_react.default.createElement("strong", null, "- Max ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
          value: Math.ceil(_this2.props.maxAllowed),
          displayType: 'text',
          thousandSeparator: true,
          prefix: '$',
          suffix: ' '
        })), "for ", offer.productTerm, " months")) : offer.valid ? /*#__PURE__*/_react.default.createElement("div", {
          id: checkBoxDiv + _this2.props.productType + idx,
          className: 'card-offer' + (_this2.props.offerSelected === _this2.props.productType + idx ? '--selected' : '')
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: 'adx-inputclass' + (_this2.props.offerSelected === _this2.props.productType + idx ? '--selected' : '')
        }, /*#__PURE__*/_react.default.createElement("input", {
          term: offer.productTerm,
          loanType: _this2.props.productType,
          loanAmount: offer.loanAmount,
          minimumApr: offer.minimumApr,
          id: _this2.props.productType + idx,
          type: "radio",
          name: "offer",
          className: "card-offer-checkbox",
          value: _this2.props.productType + idx,
          onChange: _this2.props.selectedRadio
        })), /*#__PURE__*/_react.default.createElement("label", {
          className: "adx-card-offer-value",
          htmlFor: _this2.props.productType + idx
        }, /*#__PURE__*/_react.default.createElement("strong", null, /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
          value: Math.ceil(offer.minMonthlyPayments),
          displayType: 'text',
          thousandSeparator: true,
          prefix: '$',
          suffix: '/mo'
        })), /*#__PURE__*/_react.default.createElement("sup", {
          className: "disclosure-offeritem"
        }, _this2.props.moPaymentDisclosure), _this2.props.productType === 'prp' ? null : /*#__PURE__*/_react.default.createElement("span", null, " (sugg)"), " for ", offer.productTerm, " months", /*#__PURE__*/_react.default.createElement("br", null), "at ", offer.minimumApr, "% APR -", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
          value: Math.ceil(offer.minimumTotalCost),
          displayType: 'text',
          thousandSeparator: true,
          prefix: ' $',
          suffix: ' total'
        }))) : /*#__PURE__*/_react.default.createElement("div", {
          className: "card-offer"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "adx-inputclass"
        }, /*#__PURE__*/_react.default.createElement("input", {
          type: "radio",
          name: "offer",
          className: "card-offer-checkbox",
          disabled: true
        })), /*#__PURE__*/_react.default.createElement("label", {
          className: "adx-card-offer-value--disbaled"
        }, /*#__PURE__*/_react.default.createElement("strong", null, "Min ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
          value: Math.ceil(offer.minimumAmount),
          displayType: 'text',
          thousandSeparator: true,
          prefix: '$',
          suffix: ' '
        })), /*#__PURE__*/_react.default.createElement("strong", null, "- Max ", /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
          value: Math.ceil(_this2.props.maxAllowed),
          displayType: 'text',
          thousandSeparator: true,
          prefix: '$',
          suffix: ' '
        })), "for ", offer.productTerm, " months"));
      })) : null;
    }
  }]);
  return Offers;
}(_react.default.Component);
Offers.propTypes = {
  offers: _propTypes.default.arrayOf(Shapes.Product),
  selectedRadio: _propTypes.default.arrayOf(Shapes.ProductSelected),
  productType: _propTypes.default.string,
  moPaymentDisclosure: _propTypes.default.number,
  offerSelected: _propTypes.default.string,
  inValidInput: _propTypes.default.bool,
  maxAllowed: _propTypes.default.string
};
var _default = Offers;
exports.default = _default;
